import { Head } from "@inertiajs/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";
import { useHttpErrorTexts } from "@Hooks/useHttpErrorTexts";

import { GuestLayout } from "@Layouts/GuestLayout";

ErrorGuest.layout = (page) => <GuestLayout>{page}</GuestLayout>;

export default function ErrorGuest({ status }) {
    const { errorTitle, errorDescription } = useHttpErrorTexts(status);

    return (
        <>
            <Head>
                <title>Ett fel uppstod</title>
            </Head>

            <div className="text-center py-5 ">
                <h1 className="page-header">
                    <FontAwesomeIcon
                        icon={faCircleExclamation}
                        className="text-primary me-1"
                    />{" "}
                    Ett fel uppstod
                </h1>
                <div>{errorDescription}</div>
                <div className="text-muted mt-3">
                    <i>{errorTitle}</i>
                </div>
            </div>
        </>
    );
}
